import React, { Component } from 'react'
import TopBar from '../../components/TopBar'
import BottomBar from '../../components/BottomBar'
import api from '../../api'
import './Login.css'
import '../styles.css'

class Login extends Component {

  state = {
    missingParameter: 'none',
    warning: '',
  }

  storeEmail = async (event) => {
    await this.setState({ email: event.target.value })
  }

  storePassword = async (event) => {
    await this.setState({ password: event.target.value })
  }

  componentWillMount() {
    document.addEventListener("keyup", this.handleEnter);

    const token = localStorage.token
    const { history } = this.props
    if (token) {
      history.push({ pathname: '/oversikt', search: history.location.search })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleEnter)
  }

  handleEnter = (event) => {
    event.preventDefault();
    if (event.keyCode === 13) {
      document.getElementById("Login-button").click();
    }
  }

  login = async () => {
    const { email, password } = this.state
    const missingParameter = !email || email === '' ? 'email'
      : !password || password === '' ? 'password'
        : 'none'
    if (missingParameter === 'none') {
      const token = await api('login', { email, password })
      const user = await api('authenticate', { token })

      if (user) {
        localStorage.token = token
        this.props.history.push({ pathname: '/oversikt', search: this.props.history.location.search })
      } else {
        this.setState({
          warning:
            'feil epost/passord'
        })
      }
      //TODO 
      //redirect
    } else {
      await this.setState({ missingParameter })
      await this.setState({ warning: 'Vennligst fill inn manglende data!' })
    }
  }

  render() {
    const { email, password, missingParameter, warning } = this.state
    const outlineEmail = missingParameter === 'email' &&
      (email === '' || !email)
    const outlinePassword = missingParameter === 'password' &&
      (password === '' || !password)

    return (
      <div className="OuterContainer" id="OuterContainer">
        <div className="Height-100 flex-column">
          <TopBar activePage={'Logg inn'} />
          <div className="Column-center-aligned Height-minus-bottom-bar Center-aligned flex-grow flex-column">
            <div className="Container-cinderella">
              <div className="Kursmateriell-container">
                <div className="Column ">
                  <div className="Row Flex-1 Center-content">
                    <div className="Kursmateriell-main-title Width-700">

                      Min side
                    </div>
                  </div>


                  <div className="Empty-space-25" />
                  <div className="Column-center-aligned Center-aligned">
                    <div className="Login-title-type2">
                      Innlogging
                    </div>
                    <div className="Empty-space-25" />
                    <input
                      className={
                        outlineEmail ?
                          "Bestill-small-input Red-outline"
                          : "Bestill-small-input"
                      }
                      placeholder="E-post"
                      type="text"
                      onChange={this.storeEmail}
                    />
                    <div className="Empty-space-15" />
                    <input
                      className={
                        outlinePassword ?
                          "Bestill-small-input Red-outline"
                          : "Bestill-small-input"
                      }
                      placeholder="password"
                      id="Login-password"
                      type="password"
                      onChange={this.storePassword}
                    />
                    <div className="Empty-space-25" />
                    {warning === '' ?
                      null
                      :
                      <div>
                        <div className="Warning">

                          {warning}
                        </div>
                        <div className="Empty-space-15" />
                      </div>
                    }
                    <button
                      className="Login-button"
                      id="Login-button"
                      onClick={this.login}
                    >
                      Logg inn
                    </button>
                    <div className="Empty-space-25" />
                  </div>
                  <div className="Empty-space-55" />
                </div>
              </div>
            </div>
          </div>
          <BottomBar />
        </div>
      </div>
    )
  }
}

export default Login 



// WEBPACK FOOTER //
// ./src/pages/Login/index.js